import { useNavigate } from 'react-router-dom';

const NEWSLETTER_URL = 'https://readdy.ai/api/form/d9b5i114iotnakcn9f5g';

export default function Footer() {
  const navigate = useNavigate();

  async function handleNewsletterSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      alert('Vielen Dank für Ihre Anmeldung!');
      form.reset();
      return;
    }

    const formData = new FormData(form);
    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'website_alt') {
        params.append(key, value as string);
      }
    });

    try {
      const res = await fetch(NEWSLETTER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(text); } catch { /* ignore */ }

      if (res.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        alert('Vielen Dank für Ihre Anmeldung!');
        form.reset();
      } else {
        const msg = (parsed as Record<string, string>)?.message || 'Ein Fehler ist aufgetreten.';
        alert(msg);
      }
    } catch {
      alert('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
    }
  }

  return (
    <footer className="bg-foreground-950 rounded-t-3xl">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 pt-16 pb-10 relative overflow-hidden">
        <div className="absolute bottom-0 left-0 right-0 select-none pointer-events-none opacity-[0.03]">
          <p className="text-white text-[10rem] md:text-[14rem] font-heading font-bold leading-none text-center">
            OOPBUY
          </p>
        </div>

        <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <h3 className="text-white text-xl md:text-2xl font-heading font-bold mb-4">
              Bereit loszulegen?
            </h3>
            <p className="text-secondary-400 text-sm leading-relaxed">
              Entdecke das OOPBUY Spreadsheet und finde die besten Produkte zu den günstigsten Preisen.
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium mb-4">Navigation</h4>
            <div className="flex flex-col gap-2.5">
              <a href="/" className="text-secondary-400 hover:text-white text-sm transition-colors">
                Startseite
              </a>
              <button
                onClick={() => navigate('/artikel/oopbuy-spreadsheet-guide')}
                className="text-secondary-400 hover:text-white text-sm transition-colors text-left cursor-pointer"
              >
                OOPBUY Guide
              </button>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-secondary-400 hover:text-white text-sm transition-colors"
              >
                oopbuy spreadsheet
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium mb-4">Social Media</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#" target="_blank" rel="noopener nofollow" className="text-secondary-400 hover:text-white text-sm transition-colors flex items-center gap-2">
                <i className="ri-instagram-line text-base" /> Instagram
              </a>
              <a href="#" target="_blank" rel="noopener nofollow" className="text-secondary-400 hover:text-white text-sm transition-colors flex items-center gap-2">
                <i className="ri-youtube-line text-base" /> YouTube
              </a>
              <a href="#" target="_blank" rel="noopener nofollow" className="text-secondary-400 hover:text-white text-sm transition-colors flex items-center gap-2">
                <i className="ri-facebook-line text-base" /> Facebook
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium mb-4">Newsletter</h4>
            <p className="text-secondary-400 text-xs mb-3">
              Bleibe auf dem Laufenden über neue OOPBUY Spreadsheet Updates.
            </p>
            <form
              onSubmit={handleNewsletterSubmit}
              data-readdy-form=""
              className="flex gap-0"
            >
              <input
                type="email"
                name="email"
                required
                placeholder="Deine E-Mail"
                className="flex-1 bg-white/10 border border-white/20 rounded-l-full px-4 py-2.5 text-sm text-white placeholder:text-secondary-500 outline-none focus:border-white/40 transition-colors"
              />
              <button
                type="submit"
                className="bg-accent-500 hover:bg-accent-600 text-white px-5 rounded-r-full flex items-center justify-center transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-right-line" />
              </button>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="anti-spam-field"
              />
            </form>
          </div>
        </div>

        <div className="relative z-10 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-secondary-500 text-xs">
            &copy; {new Date().getFullYear()} oopbuyspread.top – Eine unabhängige Informationsplattform
          </p>
          <p className="text-secondary-500 text-xs">
            Keine direkte Verbindung zu OOPBUY. Nur Informationen und Guides.
          </p>
        </div>
      </div>
    </footer>
  );
}